import React, { useEffect, useRef } from "react";
import "../styles/SingleQRcode.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BackArrow from "../icons/BusinessHub/BackArrow.js";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import { useState } from "react";
import CustomDropdown from "./StatusDropdown";
import TrashIcon from "../icons/BusinessHub/TrashIcon.js";
import RefreshIcon from "../icons/BusinessHub/RefreshIcon.js";
import Uploadbutton from "../icons/BusinessHub/Uploadbutton.js";
import CountriesController from "../controllers/CountriesController.js";
import Utils from "../utils/Utils.js";
import { userService } from "../services/userService.js";
import companyController from "../controllers/companyController.js";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon.js";
import XIcon from "../icons/XIcon.js";
import { useLocation } from "react-router-dom";
import ProductController from "../controllers/ProductController.js";
import { toast } from "react-toastify";
import PromotionController from "../controllers/PromotionController.js";
import colorName from "color-name";
import ScannerIcon from "../icons/ScannerIcon.js";
import SingleBarcodeScanner from "./SingleBarcodeScanner.js";
import QrPrintDesigner from "./QrPrintDesigner.js";
import useTableNavigationState from "../utils/useTableNavigationState.js";

const DESCRIPTION_MAX_LENGTH = 1000;

const createEmptySku = (id) => ({
  // id,
  // azaleaBarcode: "",
  // barcode: "",
  // // size: "",
  // material: "",
  // colorName: "Black",
  // colorValue: "#000000",
  // price: "",
  // costPriceValue: "",
  // currency: "USD",
  // stockQuantity: "",
  // initialStockQuantity: "",
  // reservedStockQuantity: "",
  // unitOfMeasure: "",
  // length: "",
  // width: "",
  // height: "",
  // unitOfDimensions: "",
  // skuCode: "",
  // technicalSpecs: "",
  // images: [],
  // videos: [],

  id,
  azaleaBarcode: "",
  barcode: "",

  colorInfo: [
    {
      colorName: "Black",
      colorValue: "#000000",
    },
  ],

  material: "N/A",
  model: "",
  size: "ONE_SIZE",

  price: "",
  costPriceValue: "",
  currency: "USD",

  stockQuantity: "0",
  initialStockQuantity: "0",
  reservedStockQuantity: "0",

  unitOfMeasure: "KILOGRAM",

  productWeight: "",
  packageWeight: "",

  // dimensions: {
  //   length: "",
  //   width: "",
  //   height: "",
  //   unitOfDimensions: "",
  // },

  productDimensions: {
    length: "",
    width: "",
    height: "",
    unitOfDimensions: "CM",
  },

  packageDimensions: {
    length: "",
    width: "",
    height: "",
    unitOfDimensions: "CM",
  },

  skuCode: "",
  technicalSpecs: "empty",

  productImages: [],
  productVideos: [],
});

const parseIntegerOrNull = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number.parseInt(String(value), 10);
  return Number.isNaN(n) ? null : n;
};
const parseDoubleOrNull = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(String(v).replace(/[^0-9.-]/g, "")); // removes $, commas, etc
  return Number.isFinite(n) ? n : null;
};
const toStringOrNull = (v) => {
  if (v === null || v === undefined || v === "") return null;
  return String(v).trim();
};
const normalizeDimensionForm = (dimensions, fallback = {}) => ({
  length: dimensions?.length ?? fallback?.length ?? "",
  width: dimensions?.width ?? fallback?.width ?? "",
  height: dimensions?.height ?? fallback?.height ?? "",
  unitOfDimensions:
    dimensions?.unitOfDimensions ?? fallback?.unitOfDimensions ?? "CM",
});
const buildDimensionPayload = (dimensions) => ({
  height: parseDoubleOrNull(dimensions?.height),
  length: parseDoubleOrNull(dimensions?.length),
  unitOfDimensions: toStringOrNull(dimensions?.unitOfDimensions) || "CM",
  width: parseDoubleOrNull(dimensions?.width),
});
const formatColorName = (name) =>
  String(name || "")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(
      /(blue|brown|coral|cyan|gold|goldenrod|gray|green|grey|khaki|lavender|magenta|orange|orchid|pink|purple|red|salmon|slate|turquoise|violet|white|yellow)/gi,
      " $1",
    )
    .trim()
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const normalizeColorSearchValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/grey/g, "gray")
    .replace(/[^a-z0-9]/g, "");

const rgbToHex = (rgb) =>
  `#${rgb
    .map((value) => value.toString(16).padStart(2, "0"))
    .join("")
    .toUpperCase()}`;

const buildColorPreset = (rawName, rgb) => {
  const name = formatColorName(rawName);
  const value = rgbToHex(rgb);

  return {
    name,
    rawName,
    value,
    searchName: normalizeColorSearchValue(name),
    searchRawName: normalizeColorSearchValue(rawName),
    searchAliases: [
      normalizeColorSearchValue(name),
      normalizeColorSearchValue(rawName),
    ],
    searchHex: normalizeColorSearchValue(value),
  };
};

const COLOR_PRESETS = [
  ...Array.from(
    Object.entries(colorName)
      .reduce((presetsByValue, [rawName, rgb]) => {
        const preset = buildColorPreset(rawName, rgb);
        const existingPreset = presetsByValue.get(preset.value);

        if (!existingPreset) {
          presetsByValue.set(preset.value, preset);
          return presetsByValue;
        }

        presetsByValue.set(preset.value, {
          ...existingPreset,
          searchAliases: Array.from(
            new Set([...existingPreset.searchAliases, ...preset.searchAliases])
          ),
        });

        return presetsByValue;
      }, new Map())
      .values()
  ),

  buildColorPreset("Stainless Steel", [176, 183, 189]),
];

const getColorSearchScore = (color, searchValue) => {
  const terms = [
    color.searchName,
    color.searchRawName,
    color.searchHex,
    ...color.searchAliases,
  ];
  const words = color.name
    .split(/\s+/)
    .map((word) => normalizeColorSearchValue(word));

  const getBestScore = (values, scoreForValue) =>
    values.reduce((bestScore, value) => {
      const score = scoreForValue(value);
      return score < bestScore ? score : bestScore;
    }, Number.POSITIVE_INFINITY);

  const fullNameScore = getBestScore(terms, (term) => {
    if (term === searchValue) return 0;
    if (term.startsWith(searchValue))
      return 100 + term.length - searchValue.length;

    const index = term.indexOf(searchValue);
    if (index !== -1)
      return 300 + index * 10 + term.length - searchValue.length;

    return Number.POSITIVE_INFINITY;
  });

  const wordScore = getBestScore(words, (word) => {
    if (word === searchValue) return 200 + color.searchName.length;
    if (word.startsWith(searchValue))
      return 400 + color.searchName.length + word.length - searchValue.length;

    const index = word.indexOf(searchValue);
    if (index !== -1)
      return (
        500 +
        color.searchName.length +
        index * 10 +
        word.length -
        searchValue.length
      );

    return Number.POSITIVE_INFINITY;
  });

  return Math.min(fullNameScore, wordScore);
};

const getColorNameFromHex = (hex) => {
  const matchedColor = COLOR_PRESETS.find(
    (color) => color.value.toLowerCase() === String(hex).toLowerCase(),
  );
  return matchedColor ? matchedColor.name : "Custom";
};

const getLettersOnly = (value) =>
  String(value || "")
    .replace(/[^a-zA-Z]/g, "")
    .toUpperCase();

const getDigitsOnly = (value) => String(value || "").replace(/\D/g, "");

const getColorNumericDigits = (colorValue) => {
  const cleanedHex = String(colorValue || "").replace("#", "");
  if (!cleanedHex) return "";
  const parsed = Number.parseInt(cleanedHex, 16);
  return Number.isNaN(parsed) ? "" : String(parsed);
};

const normalizeHexColor = (value) => {
  const hex = String(value || "").trim();
  if (!hex) return null;

  const normalized = hex.startsWith("#") ? hex : `#${hex}`;
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(normalized)
    ? normalized.toUpperCase()
    : null;
};

const MAX_IMAGE_SIZE_MB = 200;

const getAttachmentBase64 = (attachment) => {
  const rawData = String(attachment?.data || "").trim();
  if (!rawData) return "";

  if (rawData.startsWith("data:")) {
    return rawData.split(",")[1] || "";
  }

  return rawData;
};

const buildAttachmentName = (attachment, index) => {
  const objectName = String(attachment?.objectName || "").trim();
  if (objectName) return objectName;

  const extension = String(attachment?.extension || "")
    .trim()
    .toLowerCase();

  return extension
    ? `product-image-${index + 1}.${extension}`
    : `product-image-${index + 1}`;
};

const normalizeFetchedSku = (sku, index) => {
  const skuId =
    sku?.skuID ?? sku?.skuId ?? sku?.id ?? `fetched-sku-${index + 1}`;
  const firstColor = Array.isArray(sku?.colorInfo) ? sku.colorInfo[0] : null;
  const productImages = Array.isArray(sku?.productImages)
    ? sku.productImages
    : [];
  const productVideos = Array.isArray(sku?.productVideos)
    ? sku.productVideos
    : [];
  const dimensions = normalizeDimensionForm(sku?.dimensions);
  const productDimensions = normalizeDimensionForm(
    sku?.productDimensions,
    sku?.dimensions,
  );
  const packageDimensions = normalizeDimensionForm(sku?.packageDimensions);

  return {
    ...createEmptySku(skuId),
    id: skuId,
    size: sku?.size ?? "ONE_SIZE",
    material: sku?.material ?? "N/A",
    model: sku?.model ?? "",
    colorName:
      firstColor?.colorName ??
      (normalizeHexColor(firstColor?.colorValue)
        ? getColorNameFromHex(firstColor?.colorValue)
        : "Black"),
    colorValue: normalizeHexColor(firstColor?.colorValue) || "#000000",
    price: sku?.price ?? "",
    costPriceValue: sku?.costPriceValue ?? "",
    currency: sku?.currency ?? "USD",
    stockQuantity: sku?.stockQuantity ?? "0",
    initialStockQuantity: sku?.initialStockQuantity ?? "0",
    reservedStockQuantity: sku?.reservedStockQuantity ?? "0",
    unitOfMeasure: sku?.unitOfMeasure ?? "KILOGRAM",
    barcode: sku?.barcode ?? "",
    azaleaBarcode: sku?.azaleaBarcode ?? "",
    productWeight: sku?.productWeight ?? "",
    packageWeight: sku?.packageWeight ?? "",
    dimensions,
    productDimensions,
    packageDimensions,
    skuCode: sku?.skuCode ?? "",
    technicalSpecs: sku?.technicalSpecs ?? "empty",
    images: productImages
      .map((attachment, imageIndex) => {
        const base64 = getAttachmentBase64(attachment);
        if (!base64) return null;
        return {
          id:
            attachment?.attachmentID ??
            attachment?.id ??
            `${skuId}-image-${imageIndex + 1}`,
          name: buildAttachmentName(attachment, imageIndex),
          base64,
        };
      })
      .filter(Boolean),
    videos: productVideos
      .map((attachment, videoIndex) => {
        const base64 = getAttachmentBase64(attachment);
        if (!base64) return null;
        return {
          id:
            attachment?.attachmentID ??
            attachment?.id ??
            `${skuId}-video-${videoIndex + 1}`,
          name: buildAttachmentName(attachment, videoIndex),
          base64,
        };
      })
      .filter(Boolean),
  };
};

const normalizeFetchedBasicInfo = (basicInfo) => ({
  productName: basicInfo?.productName ?? "",
  category: basicInfo?.category ?? "",
  categoryId: basicInfo?.categoryId ?? "",
  description: basicInfo?.description ?? "",
  brand: basicInfo?.brand ?? "",
  countryOfProduction: basicInfo?.countryOfProduction ?? "",
  source: basicInfo?.source ?? "",
});

const normalizeCategoryOption = (category) => ({
  categoryId: String(category?.categoryId || category?.id || "").trim(),
  categoryName: String(category?.categoryName || category?.label || "").trim(),

  subCategories: Array.isArray(category?.subCategories)
    ? category.subCategories
    : [],
});

const getCategoryValue = (category) =>
  String(category?.categoryName || "").trim();

const NO_SUBCATEGORY_VALUE = "__NO_SUBCATEGORY__";

const findMatchingCategory = (categories, value) => {
  const normalizedValue = String(value || "")
    .trim()
    .toUpperCase();
  if (!normalizedValue) return null;

  return (
    categories.find(
      (category) =>
        String(category.categoryId).trim().toUpperCase() === normalizedValue ||
        String(category.categoryName).trim().toUpperCase() === normalizedValue,
    ) || null
  );
};

const findMatchingSubCategory = (SubCategories, value) => {
  const normalizedValue = String(value || "")
    .trim()
    .toUpperCase();
  if (!normalizedValue) return null;
  return (
    SubCategories.find(
      (category) =>
        String(category.subCategoryId).trim().toUpperCase() ===
          normalizedValue ||
        String(category.subCategoryName).trim().toUpperCase() ===
          normalizedValue,
    ) || null
  );
};

const hasBarcodeProductData = (candidate) =>
  Boolean(
    candidate?.basicInfo ||
    (Array.isArray(candidate?.skus) && candidate.skus.length > 0) ||
    ["barcode", "name", "brand", "skuCode", "productName"].some(
      (field) =>
        candidate?.[field] !== null && candidate?.[field] !== undefined,
    ),
  );

const getBarcodeProductFromResponse = (response) => {
  const candidates = [response];
  const visited = new Set();

  while (candidates.length > 0) {
    const candidate = candidates.shift();

    if (typeof candidate === "string") {
      try {
        candidates.push(JSON.parse(candidate));
      } catch {
        // Ignore non-JSON response text.
      }
      continue;
    }

    if (!candidate || typeof candidate !== "object") continue;
    if (visited.has(candidate)) continue;
    visited.add(candidate);

    if (Array.isArray(candidate)) {
      candidates.push(...candidate);
      continue;
    }

    if (hasBarcodeProductData(candidate)) {
      return candidate;
    }

    ["data", "product", "result", "content", "body", "payload"].forEach(
      (field) => {
        if (candidate[field] !== undefined) {
          candidates.push(candidate[field]);
        }
      },
    );
  }

  return null;
};

const isPlaceholderImageValue = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase();

  return ["", "string", "null", "undefined"].includes(normalized);
};

const getBarcodeImageValue = (image) => {
  if (!image || typeof image !== "object") return image;

  const candidates = [
    image.data,
    image.url,
    image.customPath,
    image.image,
    image.imageUrl,
    image.imageURL,
    image.src,
    image.path,
  ].filter((value) => !isPlaceholderImageValue(value));

  const existingBase64 = candidates.find((value) => {
    const imageValue = String(value || "").trim();
    return (
      imageValue.startsWith("data:image/") ||
      (!/^https?:\/\//i.test(imageValue) && !imageValue.includes("://"))
    );
  });

  return (
    existingBase64 ||
    candidates.find((value) => /^https?:\/\//i.test(String(value).trim())) ||
    candidates[0]
  );
};

const flattenBarcodeImages = (images) =>
  images
    .flatMap((image) => (Array.isArray(image) ? image : [image]))
    .filter(Boolean);

const getImageExtension = (value, fallback = "jpg") => {
  const imageValue = String(value || "").trim();
  const dataUrlMatch = imageValue.match(/^data:image\/([^;]+);base64,/i);

  if (dataUrlMatch?.[1]) {
    return dataUrlMatch[1].toLowerCase() === "jpeg"
      ? "jpg"
      : dataUrlMatch[1].toLowerCase();
  }

  try {
    const pathname = new URL(imageValue).pathname;
    const extension = pathname.split(".").pop()?.split(/[?#]/)[0];
    return extension || fallback;
  } catch {
    return fallback;
  }
};

const getBarcodeImageName = (image, index, barcode) => {
  if (image && typeof image === "object") {
    const existingName = String(
      image.objectName || image.name || image.label || "",
    ).trim();

    if (existingName) return existingName;
  }

  const imageValue =
    image && typeof image === "object" ? getBarcodeImageValue(image) : image;
  const extension = getImageExtension(imageValue);
  const safeBarcode = String(barcode || "barcode-product").replace(
    /[^a-zA-Z0-9_-]/g,
    "",
  );

  return `${safeBarcode || "barcode-product"}-${index + 1}.${extension}`;
};

const normalizeBarcodeImage = async (image, index, barcode) => {
  if (!image) return null;

  const imageValue =
    image && typeof image === "object" ? getBarcodeImageValue(image) : image;
  const rawImageValue = String(imageValue || "").trim();

  if (!rawImageValue) return null;

  let base64 = "";

  if (
    image &&
    typeof image === "object" &&
    !/^https?:\/\//i.test(rawImageValue)
  ) {
    const attachmentBase64 = getAttachmentBase64(image);
    if (!isPlaceholderImageValue(attachmentBase64)) {
      base64 = attachmentBase64;
    }
  }

  if (!base64 && rawImageValue.startsWith("data:image/")) {
    base64 = rawImageValue.split(",")[1] || "";
  }

  if (!base64 && /^https?:\/\//i.test(rawImageValue)) {
    const dataUrl = await Utils.imageUrlToBase64(rawImageValue);
    base64 = dataUrl?.split(",")[1] || "";
  }

  if (!base64 && !rawImageValue.includes("://")) {
    base64 = rawImageValue;
  }

  if (!base64) return null;

  return {
    id: Utils.generateFileId(),
    name: getBarcodeImageName(image, index, barcode),
    base64,
    sourceUrl: /^https?:\/\//i.test(rawImageValue) ? rawImageValue : "",
  };
};

const normalizeBarcodeImages = async (scannedProduct, fallbackImages = []) => {
  const imageCandidates = [
    scannedProduct?.image,
    scannedProduct?.images,
    scannedProduct?.productImages,
  ];
  const ownImages = flattenBarcodeImages(imageCandidates);
  const flattenedImages =
    ownImages.length > 0 ? ownImages : flattenBarcodeImages(fallbackImages);

  const normalizedImages = await Promise.all(
    flattenedImages.map((image, index) =>
      normalizeBarcodeImage(image, index, scannedProduct?.barcode),
    ),
  );

  return normalizedImages.filter(Boolean);
};

const normalizeBarcodeBasicInfo = (scannedProduct, previousBasicInfo = {}) => {
  const responseBasicInfo =
    scannedProduct?.basicInfo && typeof scannedProduct.basicInfo === "object"
      ? scannedProduct.basicInfo
      : scannedProduct;

  return {
    productName:
      responseBasicInfo?.productName ??
      scannedProduct?.productName ??
      scannedProduct?.name ??
      previousBasicInfo.productName ??
      "",
    category: responseBasicInfo?.category ?? previousBasicInfo.category ?? "",
    categoryId:
      responseBasicInfo?.categoryId ?? previousBasicInfo.categoryId ?? "",
    description:
      responseBasicInfo?.description ??
      scannedProduct?.description ??
      previousBasicInfo.description ??
      "",
    brand:
      responseBasicInfo?.brand ??
      scannedProduct?.brand ??
      previousBasicInfo.brand ??
      "",
    countryOfProduction:
      responseBasicInfo?.countryOfProduction ??
      scannedProduct?.countryOfProduction ??
      previousBasicInfo.countryOfProduction ??
      "",
    source:
      responseBasicInfo?.source ??
      scannedProduct?.source ??
      previousBasicInfo.source ??
      "",
  };
};

const normalizeBarcodeSku = async (
  sku,
  index,
  selectedBarcode,
  fallbackImages = [],
) => {
  const skuId =
    sku?.skuID ?? sku?.skuId ?? sku?.id ?? `barcode-sku-${index + 1}`;
  const firstColor = Array.isArray(sku?.colorInfo) ? sku.colorInfo[0] : null;
  const images = await normalizeBarcodeImages(
    {
      ...sku,
      barcode: sku?.barcode ?? selectedBarcode,
    },
    fallbackImages,
  );
  const dimensions = normalizeDimensionForm(sku?.dimensions);
  const productDimensions = normalizeDimensionForm(
    sku?.productDimensions,
    sku?.dimensions,
  );
  const packageDimensions = normalizeDimensionForm(sku?.packageDimensions);

  return {
    ...createEmptySku(skuId),
    id: skuId,
    size: sku?.size ?? "ONE_SIZE",
    material: sku?.material ?? "N/A",
    colorName:
      firstColor?.colorName ??
      (normalizeHexColor(firstColor?.colorValue)
        ? getColorNameFromHex(firstColor?.colorValue)
        : "Black"),
    colorValue: normalizeHexColor(firstColor?.colorValue) || "#000000",
    price: sku?.price ?? "",
    costPriceValue: sku?.costPriceValue ?? "",
    currency: sku?.currency ?? "USD",
    stockQuantity: sku?.stockQuantity ?? "0",
    initialStockQuantity: sku?.initialStockQuantity ?? "0",
    reservedStockQuantity: sku?.reservedStockQuantity ?? "0",
    unitOfMeasure: sku?.unitOfMeasure ?? "KILOGRAM",
    barcode:
      sku?.barcode !== null && sku?.barcode !== undefined
        ? String(sku.barcode)
        : String(selectedBarcode || ""),
    dimensions,
    productDimensions,
    packageDimensions,
    skuCode: sku?.skuCode ?? "",
    technicalSpecs:
      sku?.technicalSpecs && typeof sku.technicalSpecs === "object"
        ? JSON.stringify(sku.technicalSpecs)
        : Utils.jsonToTextList(sku?.technicalSpecs ?? "empty"),
    images,
    videos: [],
  };
};

const normalizeBarcodeSkus = async (scannedProduct, selectedBarcode) => {
  const responseSkus =
    Array.isArray(scannedProduct?.skus) && scannedProduct.skus.length > 0
      ? scannedProduct.skus
      : [scannedProduct];
  const fallbackImages = flattenBarcodeImages([
    scannedProduct?.image,
    scannedProduct?.images,
    scannedProduct?.productImages,
  ]);

  return Promise.all(
    responseSkus.map((sku, index) =>
      normalizeBarcodeSku(sku, index, selectedBarcode, fallbackImages),
    ),
  );
};

function SingleQRcode() {
  const location = useLocation();
  const fromScanner = location.state?.fromScanner;
  const [openQrPopup, setOpenQrPopup] = useState(false);
  const [qrBase64, setQrBase64] = useState(null);
  const [qrCodeLabel, setQrCodeLabel] = useState("QR: XXXX");
  const [isQrPrintDesignerOpen, setIsQrPrintDesignerOpen] = useState(false);
  const { navigateWithTableState } = useTableNavigationState();
  const [basicInfo, setBasicInfo] = useState({
    productName: "",
    category: "",
    categoryId: "",
    description: "",
    brand: "",
    countryOfProduction: "",
    source: "",
    categoryName: "",
    subCategoryId: "",
    subCategoryName: "",
  });
  const [SubCatags, setSubCatags] = useState([]);
  const [skusForm, setSkusForm] = useState([createEmptySku(1)]);
  const [countries, setcountries] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState("");
  const [openColorPickerSkuId, setOpenColorPickerSkuId] = useState(null);
  const [colorPresetSearchBySkuId, setColorPresetSearchBySkuId] = useState({});
  const colorDropdownRefs = useRef({});
  const skuCodeGenerationCountRef = useRef({});
  const qrImageSrc = (() => {
    if (!qrBase64) return "";

    if (qrBase64.startsWith("data:image")) {
      const [header, payload] = qrBase64.split(",");
      if (!payload) return qrBase64;
      return `${header},${Utils.padBase64(payload)}`;
    }

    return `data:image/png;base64,${Utils.padBase64(qrBase64)}`;
  })();

  const getQrLabel = (qrCodeId) =>
    qrCodeId ? `QR: ${String(qrCodeId).slice(0, 4)}` : "QR: XXXX";

  const handlePrintQr = () => {
    if (!qrImageSrc) return;
    setIsQrPrintDesignerOpen(true);
  };

  const updateBasicInfo = (field, value) => {
    setBasicInfo((prev) => ({ ...prev, [field]: value }));
  };

  const selectedCategory = findMatchingCategory(categories, selectedCategoryId);

  const isBlankRequiredValue = (value) =>
    String(value ?? "").trim().length === 0;

  const isDimensionMissing = (dimensions) =>
    isBlankRequiredValue(dimensions?.length) ||
    isBlankRequiredValue(dimensions?.width) ||
    isBlankRequiredValue(dimensions?.height);

  const hasMissingRequiredProductData = () => {
    if (
      isBlankRequiredValue(basicInfo.productName) ||
      isBlankRequiredValue(basicInfo.brand) ||
      isBlankRequiredValue(selectedCategoryId) ||
      // isBlankRequiredValue(selectedSubCategoryId) ||
      isBlankRequiredValue(basicInfo.countryOfProduction) ||
      isBlankRequiredValue(basicInfo.description)
    ) {
      return true;
    }

    return skusForm.some(
      (sku) =>
        // isBlankRequiredValue(sku.size) ||
        // isBlankRequiredValue(sku.material) ||
        isBlankRequiredValue(sku.model) ||
        // isBlankRequiredValue(sku.initialStockQuantity) ||
        // isBlankRequiredValue(sku.reservedStockQuantity) ||
        isBlankRequiredValue(sku.barcode) ||
        isBlankRequiredValue(sku.azaleaBarcode) ||
        isDimensionMissing(sku.packageDimensions) ||
        isDimensionMissing(sku.productDimensions) ||
        isBlankRequiredValue(sku.packageWeight) ||
        isBlankRequiredValue(sku.productWeight) ||
        isBlankRequiredValue(sku.colorValue) ||
        isBlankRequiredValue(sku.skuCode) ||
        isBlankRequiredValue(sku.currency) ||
        isBlankRequiredValue(sku.price),
      // isBlankRequiredValue(sku.technicalSpecs),
    );
  };

  const toastRequiredDataError = () => {
    toast.error("Fill required data");
    console.log("skusForm", skusForm);
  };

  const selectCategory = (categoryId) => {
    const nextCategory = findMatchingCategory(categories, categoryId);
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId("");
    setSubCatags(nextCategory?.subCategories || []);
    setBasicInfo((prev) => ({
      ...prev,
      category: getCategoryValue(nextCategory),
      categoryId: nextCategory?.categoryId || "",
      categoryName: nextCategory?.categoryName || "",
      subCategoryId: "",
      subCategoryName: "",
    }));
    GetSubCatags(categoryId);
  };

  const selectSubCategory = (subCategoryId) => {
    if (!subCategoryId || subCategoryId === NO_SUBCATEGORY_VALUE) {
      setSelectedSubCategoryId("");
      updateBasicInfo("subCategoryName", "");
      updateBasicInfo("subCategoryId", "");
      return;
    }

    const nextCategory = findMatchingSubCategory(SubCatags, subCategoryId);
    console.log("nextCategory", nextCategory);
    setSelectedSubCategoryId(subCategoryId);
    updateBasicInfo("subCategoryName", nextCategory?.subCategoryName || "");
    updateBasicInfo("subCategoryId", nextCategory?.subCategoryId || "");
    // setBasicInfo((prev) => ({
    //   ...prev,
    //   subCategoryName: nextCategory?.subCategoryName,
    //   subCategoryId: nextCategory?.subCategoryId,
    // }));
  };

  useEffect(() => {
    if (!SubCatags.length || selectedSubCategoryId) return;

    const matchedSubCategory = findMatchingSubCategory(
      SubCatags,
      basicInfo.subCategoryId || basicInfo.subCategoryName,
    );
    if (!matchedSubCategory) return;

    setSelectedSubCategoryId(matchedSubCategory.subCategoryId);
    setBasicInfo((prev) => ({
      ...prev,
      subCategoryName: matchedSubCategory.subCategoryName,
    }));
  }, [
    basicInfo.subCategoryName,
    basicInfo.subCategoryId,
    SubCatags,
    selectedSubCategoryId,
  ]);

  const updateSkuField = (id, field, value) => {
    setSkusForm((prev) =>
      prev.map((sku) => (sku.id === id ? { ...sku, [field]: value } : sku)),
    );
  };

  const updateSkuNestedField = (id, section, field, value) => {
    setSkusForm((prev) =>
      prev.map((sku) =>
        sku.id === id
          ? {
              ...sku,
              [section]: {
                ...(sku[section] || {}),
                [field]: value,
              },
            }
          : sku,
      ),
    );
  };

  const setSkuColor = (id, colorName, colorValue) => {
    setSkusForm((prev) =>
      prev.map((sku) =>
        sku.id === id
          ? {
              ...sku,
              colorName,
              colorValue,
            }
          : sku,
      ),
    );
  };

  const updateColorPresetSearch = (skuId, value) => {
    setColorPresetSearchBySkuId((prev) => ({
      ...prev,
      [skuId]: value,
    }));
  };

  const getFilteredColorPresets = (skuId) => {
    const searchValue = normalizeColorSearchValue(
      colorPresetSearchBySkuId[skuId],
    );
    if (!searchValue) return COLOR_PRESETS;

    return COLOR_PRESETS.map((color, index) => ({
      color,
      index,
      score: getColorSearchScore(color, searchValue),
    }))
      .filter(({ score }) => Number.isFinite(score))
      .sort((a, b) => a.score - b.score || a.index - b.index)
      .map(({ color }) => color);
  };
  const handleColorHexChange = (id, value) => {
    const trimmed = String(value || "").replace(/\s/g, "");

    if (trimmed === "") {
      setSkuColor(id, "Custom", "");
      return;
    }

    if (!/^#?[0-9a-fA-F]{0,6}$/.test(trimmed)) return;

    const withHash = trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    const upper = withHash.toUpperCase();
    const normalized = normalizeHexColor(upper);

    setSkuColor(
      id,
      normalized ? getColorNameFromHex(normalized) : "Custom",
      upper,
    );
  };

  const generateSkuCode = (skuData, generationCount = 0) => {
    const brandLetters = getLettersOnly(basicInfo.brand);
    const categoryLetters = getLettersOnly(basicInfo.category);

    const brandTwo = (brandLetters.slice(0, 2) || "XX").padEnd(2, "X");
    const categoryTwo = (categoryLetters.slice(0, 2) || "XX").padEnd(2, "X");
    const brandThree = (brandLetters.slice(0, 3) || "XXX").padEnd(3, "X");

    const skuDimensions = skuData.productDimensions || skuData.dimensions || {};
    const digitsFromDimensions = `${getDigitsOnly(
      skuDimensions.length,
    )}${getDigitsOnly(skuDimensions.width)}${getDigitsOnly(
      skuDimensions.height,
    )}`;
    const digitsFromStock = getDigitsOnly(skuData.initialStockQuantity);
    const digitsFromPrice = getDigitsOnly(skuData.price);
    const digitsFromColor = getColorNumericDigits(skuData.colorValue);
    const digitsFromModel = getDigitsOnly(skuData.model);
    const digitsFromBarcode = getDigitsOnly(skuData.barcode);

    // Rotate source by click: dimensions -> stock -> price -> color -> model -> barcode
    const numericSources = [
      digitsFromDimensions,
      digitsFromStock,
      digitsFromPrice,
      digitsFromColor,
      digitsFromModel,
      digitsFromBarcode,
    ];
    const startIndex =
      numericSources.length > 0
        ? (generationCount - 1) % numericSources.length
        : 0;

    let selectedDigits = "";
    for (let i = 0; i < numericSources.length; i += 1) {
      const candidate =
        numericSources[(startIndex + i) % numericSources.length];
      if (candidate) {
        selectedDigits = candidate;
        break;
      }
    }

    const baseDigits = selectedDigits || "0";
    const baseNumber = Number(baseDigits.slice(-8)) || 0;
    const numericPart = String((baseNumber + generationCount) % 10000).padStart(
      4,
      "0",
    );

    return `${brandTwo}-${categoryTwo}${brandThree}${numericPart}`;
  };

  const handleGenerateSkuCode = (skuData) => {
    const currentCount = skuCodeGenerationCountRef.current[skuData.id] || 0;
    const nextCount = currentCount + 1;
    skuCodeGenerationCountRef.current[skuData.id] = nextCount;

    updateSkuField(skuData.id, "skuCode", generateSkuCode(skuData, nextCount));
  };
  const generateRandom13Digits = () => {
    const digits = new Uint8Array(13);
    window.crypto.getRandomValues(digits);

    return Array.from(digits, (digit) => digit % 10).join("");
  };

  const generateCompanyBarcode = () => {
    const companyName = userService.getCompName() || "";

    const companyPrefix = companyName
      .replace(/[^a-zA-Z]/g, "")
      .substring(0, 2)
      .toUpperCase()
      .padEnd(2, "X");

    return `${companyPrefix}${generateRandom13Digits()}`;
  };

  const handleGenerateBarcode = (skuData) => {
    updateSkuField(skuData.id, "barcode", generateCompanyBarcode());
  };
  // const handleGenerateAzaBarcode = (skuData) => {
  //   updateSkuField(skuData.id, "azaleaBarcode", generateCompanyBarcode());
  // };

  const handleProductImagesChange = async (skuId, e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const processedFiles = [];
    const errors = [];

    for (const file of files) {
      if (!file.type.startsWith("image/")) {
        errors.push(`${file.name}: only image files are allowed`);
        continue;
      }

      if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        errors.push(`${file.name}: max file size is ${MAX_IMAGE_SIZE_MB}MB`);
        continue;
      }

      try {
        const fileData = await Utils.processImageFile(file, MAX_IMAGE_SIZE_MB);
        processedFiles.push(fileData);
      } catch (err) {
        errors.push(`${file.name}: ${err.message}`);
      }
    }

    if (processedFiles.length > 0) {
      setSkusForm((prev) =>
        prev.map((sku) =>
          sku.id === skuId
            ? { ...sku, images: [...(sku.images || []), ...processedFiles] }
            : sku,
        ),
      );
    }

    if (errors.length > 0) {
      alert(errors.join("\n"));
    }

    e.target.value = "";
  };

  const handleProductVideosChange = async (skuId, e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const processedFiles = [];
    const errors = [];

    for (const file of files) {
      if (!file.type.startsWith("video/")) {
        errors.push(`${file.name}: only video files are allowed`);
        continue;
      }

      if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        errors.push(`${file.name}: max file size is ${MAX_IMAGE_SIZE_MB}MB`);
        continue;
      }

      try {
        const fileData = await Utils.processVideoFile(file, MAX_IMAGE_SIZE_MB);
        processedFiles.push(fileData);
      } catch (err) {
        errors.push(`${file.name}: ${err.message}`);
      }
    }

    if (processedFiles.length > 0) {
      setSkusForm((prev) =>
        prev.map((sku) =>
          sku.id === skuId
            ? { ...sku, videos: [...(sku.videos || []), ...processedFiles] }
            : sku,
        ),
      );
    }

    if (errors.length > 0) {
      alert(errors.join("\n"));
    }

    e.target.value = "";
  };
  const GetSubCatags = async (CatagoryId) => {
    const selectedCategoryOption = findMatchingCategory(categories, CatagoryId);
    if (selectedCategoryOption?.subCategories?.length) {
      setSubCatags(selectedCategoryOption.subCategories);
    }

    const request = {
      categoryId: CatagoryId,
    };
    try {
      const GetSubCatags = await ProductController.getSubCategoriesByCategory({
        Authorization: userService.getUser(),
        request: request,
      });
      if (GetSubCatags && GetSubCatags.data) {
        setSubCatags(GetSubCatags?.data);
      }
    } catch (error) {}
  };
  const getValidatedCategory = () => {
    const category = selectedCategory;
    const categoryValue = getCategoryValue(category);

    if (!category?.categoryId || !categoryValue) {
      toast.error(
        "Please select a valid category from the backend category list.",
      );
      return null;
    }

    return category;
  };

  const buildProductPayload = ({ includeCategory = true } = {}) => {
    const parsedJwt = Utils.parseJwt(userService.getUser()) || {};
    const category = getValidatedCategory();

    if (!category) {
      return null;
    }

    return {
      basicInfo: {
        brand: toStringOrNull(basicInfo.brand),
        ...(includeCategory ? { category: getCategoryValue(category) } : {}),
        categoryId: category.categoryId,
        categoryName: category.categoryName,
        countryOfProduction: toStringOrNull(basicInfo.countryOfProduction),
        description: toStringOrNull(basicInfo.description),
        productName: toStringOrNull(basicInfo.productName),
        subCategoryId: toStringOrNull(basicInfo.subCategoryId),
        subCategoryName: toStringOrNull(basicInfo.subCategoryName),
        // source: toStringOrNull(basicInfo.source),
      },
      companyId: userService.getCompID(),
      skus: skusForm.map((sku) => ({
        azaleaBarcode: sku.azaleaBarcode,
        barcode: sku.barcode,
        colorInfo: normalizeHexColor(sku.colorValue)
          ? [
              {
                colorName:
                  toStringOrNull(sku.colorName) ||
                  getColorNameFromHex(sku.colorValue),
                colorValue: normalizeHexColor(sku.colorValue),
              },
            ]
          : [],
        costPriceValue: parseDoubleOrNull(sku.costPriceValue),
        currency: toStringOrNull(sku.currency),
        // dimensions: {
        //   height: parseDoubleOrNull(sku.height),
        //   length: parseDoubleOrNull(sku.length),
        //   unitOfDimensions: toStringOrNull(sku.unitOfDimensions),
        //   width: parseDoubleOrNull(sku.width),
        // },
        initialStockQuantity: parseDoubleOrNull(sku.initialStockQuantity),
        material: sku.material,
        model: sku.model,
        packageDimensions: buildDimensionPayload(sku.packageDimensions),
        packageWeight: sku.packageWeight,
        price: parseDoubleOrNull(sku.price),
        productDimensions: buildDimensionPayload(sku.productDimensions),
        productImages: (sku.images || []).map((image) => ({
          attachmentStatus: "DEFAULT",
          attachmentType: "PRODUCT_IMAGE",
          countryName: toStringOrNull(basicInfo.countryOfProduction),
          customPath: toStringOrNull(image.sourceUrl) || "string",
          data: Utils.padBase64(image.base64),
          extension: toStringOrNull(image.name.split(".").pop())?.toLowerCase(),
          objectName: image.name,
          userName: toStringOrNull(parsedJwt.username),
        })),
        productVideos: (sku.videos || []).map((video) => ({
          attachmentStatus: "DEFAULT",
          attachmentType: "PRODUCT_VIDEO",
          countryName: toStringOrNull(basicInfo.countryOfProduction),
          customPath: "string",
          data: Utils.padBase64(video.base64),
          extension: toStringOrNull(video.name.split(".").pop())?.toLowerCase(),
          objectName: video.name,
          userName: toStringOrNull(parsedJwt.username),
        })),
        productWeight: sku.productWeight,
        reservedStockQuantity: parseDoubleOrNull(sku.reservedStockQuantity),
        size: sku.size,
        skuCode: toStringOrNull(sku.skuCode),
        stockQuantity: parseDoubleOrNull(sku.stockQuantity),
        technicalSpecs: sku.technicalSpecs,
        unitOfMeasure: sku.unitOfMeasure,
      })),
      userId: parsedJwt.id,
      videoUrls: [],
    };
  };

  const handleUpdate = async () => {
    if (hasMissingRequiredProductData()) {
      toastRequiredDataError();
      return;
    }

    const payload = buildProductPayload();
    if (!payload) return;

    const updateProduct = await ProductController.updateProduct({
      productRequestDto: payload,
      productId: location.state?.ProductID,
      Authorization: userService.getUser(),
    });
    if (Utils.isSuccessResponse(updateProduct)) {
      const qrCode = updateProduct?.data?.qrCodes?.[0];
      setQrBase64(qrCode?.codeValue);
      setQrCodeLabel(getQrLabel(qrCode?.qrCodeId || qrCode?.id));
      setOpenQrPopup(true);
    } else {
      toast.error(updateProduct?.message);
    }
  };

  const handleCreate = async () => {
    if (hasMissingRequiredProductData()) {
      toastRequiredDataError();
      return;
    }

    const payload = buildProductPayload({ includeCategory: false });
    // console.log("payload", payload);
    if (!payload) return;

    const addProduct = await companyController.addProduct({
      productRequestDto: payload,
      Authorization: userService.getUser(),
    });
    if (Utils.isSuccessResponse(addProduct)) {
      const qrCode = addProduct.data.qrCodes[0];
      setQrBase64(qrCode.codeValue);
      setQrCodeLabel(getQrLabel(qrCode?.qrCodeId || qrCode?.id));
      setOpenQrPopup(true);
    }
  };
  const addCommercialSection = () => {
    setSkusForm((prev) => [...prev, createEmptySku(Date.now() + prev.length)]);
  };

  const removeCommercialSection = (id) => {
    setSkusForm((prev) =>
      prev.length > 1 ? prev.filter((sku) => sku.id !== id) : prev,
    );
  };

  useEffect(() => {
    if (openColorPickerSkuId === null) return;

    const onOutsideClick = (event) => {
      const activeDropdownRef = colorDropdownRefs.current[openColorPickerSkuId];
      if (activeDropdownRef && !activeDropdownRef.contains(event.target)) {
        setOpenColorPickerSkuId(null);
      }
    };

    const onEsc = (event) => {
      if (event.key === "Escape") {
        setOpenColorPickerSkuId(null);
      }
    };

    document.addEventListener("mousedown", onOutsideClick);
    document.addEventListener("keydown", onEsc);

    return () => {
      document.removeEventListener("mousedown", onOutsideClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [openColorPickerSkuId]);
  const [AvailableCridits, setAvailableCridits] = useState("");
  useEffect(() => {
    const getBillingsData = async () => {
      try {
        const res = await PromotionController.getPlansAndBilling({
          Authorization: userService.getUser(),
          companyId: userService.getCompID(),
        });
        if (res) {
          setAvailableCridits(res?.data?.availableCredits);
        }
      } catch (error) {}
    };
    getBillingsData();
  }, []);

  const [scanningBarcodeSkuId, setScanningBarcodeSkuId] = useState(null);
  const HandleBarCode = async (barcodeValue) => {
    const selectedBarcode = String(barcodeValue || "").trim();

    if (!selectedBarcode) {
      toast.error("Please enter or scan a barcode.");
      return;
    }

    try {
      const bybarcode = await ProductController.bybarcode({
        Authorization: userService.getUser(),
        barcode: selectedBarcode,
      });

      if (!Utils.isSuccessResponse(bybarcode)) {
        toast.error(
          bybarcode?.response?.data?.message || "Unable to check this barcode.",
        );
        return;
      }

      const scannedProduct = getBarcodeProductFromResponse(
        Utils.AESDecrypt(bybarcode.data),
      );

      if (scannedProduct) {
        const barcodeSkus = await normalizeBarcodeSkus(
          scannedProduct,
          selectedBarcode,
        );

        setBasicInfo((prev) => normalizeBarcodeBasicInfo(scannedProduct, prev));
        setSkusForm(barcodeSkus);
        toast.success("Barcode product data loaded.");
      } else {
        toast.error("The barcode response did not contain product data.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to check this barcode.",
      );
    }
  };

  const handleBarcodeDetected = (barcodeValue) => {
    if (!scanningBarcodeSkuId) return;

    if (scanningBarcodeSkuId === true) {
      setScanningBarcodeSkuId(null);
      HandleBarCode(barcodeValue);
      return;
    }

    const { skuId, fieldKey } = scanningBarcodeSkuId;
    updateSkuField(skuId, fieldKey, barcodeValue);
    setScanningBarcodeSkuId(null);
  };
  useEffect(() => {
    try {
      const getCountries = async () => {
        const countries = await CountriesController.getCountries({});
        setcountries(countries?.data?.map((item) => item.countryName));
      };
      getCountries();
    } catch (error) {
      console.log("error getting permisions");
    }
  }, []);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const response = await ProductController.getAllCategories({
          Authorization: userService.getUser(),
        });
        const categoryList = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.categories)
            ? response.data.categories
            : [];
        const normalizedCategories = categoryList
          .map(normalizeCategoryOption)
          .filter((category) => category.categoryId && category.categoryName);

        setCategories(normalizedCategories);
      } catch (error) {
        toast.error("Unable to load backend categories.");
      }
    };

    getCategories();
  }, []);

  useEffect(() => {
    if (!categories.length || selectedCategoryId) return;

    const matchedCategory = findMatchingCategory(
      categories,
      basicInfo.categoryId || basicInfo.category,
    );
    if (!matchedCategory) return;

    setSelectedCategoryId(matchedCategory.categoryId);
    setBasicInfo((prev) => ({
      ...prev,
      category: getCategoryValue(matchedCategory),
      categoryName: matchedCategory.categoryName,
    }));
  }, [
    basicInfo.category,
    basicInfo.categoryId,
    categories,
    selectedCategoryId,
  ]);

  useEffect(() => {
    if (!fromScanner) return;
    const productRequest = {
      businessProfileID: userService.getBPID(),
      companyId: userService.getCompID(),
      productId: location.state?.ProductID,
    };
    const GetProductDetails = async () => {
      const GetProductDetails = await ProductController.getProductDetails({
        Authorization: userService.getUser(),
        productRequest,
      });
      if (GetProductDetails.data) {
        setBasicInfo(
          normalizeFetchedBasicInfo(GetProductDetails.data.basicInfo),
        );
        const skus =
          Array.isArray(GetProductDetails.data.skus) &&
          GetProductDetails.data.skus.length
            ? GetProductDetails.data.skus.map((sku) => ({
                ...normalizeFetchedSku(sku),
                images: [],
                videos: [],
              }))
            : [createEmptySku(1)];
        setSkusForm(skus);
      }
    };
    GetProductDetails();
  }, [fromScanner, location.state?.ProductID]);

  const isProductSubmitIncomplete = hasMissingRequiredProductData();

  return (
    <div className="main-page-create-single-qr">
      <div className="create-qr-page-header">
        <BusinessHubHeader />
      </div>
      <div className="create-qr-content-main-container">
        {openQrPopup && (
          <div className="qr-modal-overlay">
            <div className="qr-model-create-qr-for-product">
              <div className="qr-enroll-overlay">
                <div
                  className="qr-popup-close-button"
                  onClick={() => {
                    setOpenQrPopup(false);
                    navigateWithTableState("/Qr-code-management");
                  }}
                >
                  <XIcon stroke="#424242" />
                </div>
                <div className="qr-creation-header">
                  <div className="qr-enroll-qr-box qr-enroll-qr-box-icon">
                    <SuccTickIcon />
                  </div>
                  <div className="create-qr-code-title-text">
                    QR Code Created Successfully
                  </div>
                  <div className="qr-enroll-qr-box qr-enroll-qr-box-image">
                    {qrImageSrc ? (
                      <img
                        className="qr-popup-image"
                        src={qrImageSrc}
                        alt="Product QR Code"
                      />
                    ) : null}
                  </div>
                  <div className="qr-popup-code-label">{qrCodeLabel}</div>
                  <div className="qr-creation-action">
                    <div
                      className="create-single-qr-action-button"
                      onClick={handlePrintQr}
                    >
                      Print
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <QrPrintDesigner
          open={isQrPrintDesignerOpen}
          qrItems={[
            {
              imageSrc: qrImageSrc,
              label: qrCodeLabel,
              productName: basicInfo.productName,
              companyName: userService.getCompName?.() || "",
            },
          ]}
          title="Customize QR Print"
          subtitle="Add a logo and adjust this QR label before printing."
          onClose={() => setIsQrPrintDesignerOpen(false)}
          onPrinted={() => setIsQrPrintDesignerOpen(false)}
        />
        <div className="create-qr-content-container-single">
          <div className="create-qr-data-header">
            <div className="create-qr-header-navigation">
              {fromScanner ? null : (
                <div
                  className="create-qr-header-navigation-icon"
                  onClick={() => navigateWithTableState("/Qr-code-management")}
                >
                  <BackArrow />
                </div>
              )}

              <div className="create-qr-header-navigation-text">
                QR Code Management
              </div>
            </div>

            <div className="create-qr-header-text">
              <div className="create-qr-header-title">
                Create Single QR Code
              </div>
              <div className="create-qr-header-text-note">
                Generate a QR code for a specific product with custom
                configuration.
              </div>
            </div>
          </div>
          <div className="create-qr-body">
            <div className="create-qr-body-basic-info">
              <div className="create-qr-basic-info-title-smart-fill">
                <span className="av-cridits-add-prod">
                  Available Credits {AvailableCridits}
                </span>
                <span className="smart-fill-add-prod">
                  Smart Fill
                  <label className="company-setting-switch">
                    <input
                      type="checkbox"
                      checked={scanningBarcodeSkuId === true}
                      onChange={(e) =>
                        setScanningBarcodeSkuId(e.target.checked ? true : null)
                      }
                    />
                    <span className="company-setting-slider"></span>
                  </label>
                </span>
              </div>
              <div className="create-qr-basic-info-title">
                1. Basic Product Information
              </div>
              <div className="create-qr-basic-info-body">
                <div className="create-qr-basic-info-body-input">
                  <div className="basic-info-body">
                    <div className="basic-info-body-title">
                      <div className="basic-info-body-title-text">
                        Product Name <span className="required">*</span>
                      </div>
                      <div className="basic-info-body-title-input-container">
                        <input
                          className="basic-info-body-title-input"
                          value={basicInfo.productName}
                          onChange={(e) =>
                            updateBasicInfo("productName", e.target.value)
                          }
                        ></input>
                      </div>
                    </div>

                    <div className="basic-info-body-title">
                      <div className="basic-info-body-title-text">
                        Brand <span className="required">*</span>
                      </div>
                      <div className="basic-info-body-title-input-container">
                        <input
                          className="basic-info-body-title-input"
                          value={basicInfo.brand}
                          onChange={(e) =>
                            updateBasicInfo("brand", e.target.value)
                          }
                        ></input>
                      </div>
                    </div>
                  </div>

                  <div className="basic-info-body">
                    <div className="basic-info-body-title">
                      <div className="basic-info-body-title-text">
                        Category <span className="required">*</span>
                      </div>
                      <CustomDropdown
                        searchable
                        rightIcon={<ArrowDownIcon />}
                        value={selectedCategoryId}
                        onChange={selectCategory}
                        placeholder="Select Category"
                        options={categories.map((category) => ({
                          label: category.categoryName,
                          value: category.categoryId,
                        }))}
                        className="filter-popup-container-rows-input-container"
                        menuClassName="status-drop-menu-container"
                        optionClassName="status-drop-menu-option"
                      />
                    </div>
                    <div className="basic-info-body-title">
                      <div className="basic-info-body-title-text">
                        Sub Category
                      </div>
                      <CustomDropdown
                        searchable
                        rightIcon={<ArrowDownIcon />}
                        value={selectedSubCategoryId}
                        onChange={selectSubCategory}
                        placeholder="Select Sub Category"
                        options={[
                          { label: "None", value: NO_SUBCATEGORY_VALUE },
                          ...SubCatags.map((SubCatags) => ({
                            label: SubCatags.subCategoryName,
                            value: SubCatags.subCategoryId,
                          })),
                        ]}
                        className="filter-popup-container-rows-input-container"
                        menuClassName="status-drop-menu-container"
                        optionClassName="status-drop-menu-option"
                      />
                    </div>
                  </div>
                  <div className="basic-info-body">
                    <div className="basic-info-body-country">
                      <div className="basic-info-body-title-text">
                        Country of production
                        <span className="required">*</span>
                      </div>
                      <CustomDropdown
                        rightIcon={<ArrowDownIcon />}
                        searchable={true}
                        value={basicInfo.countryOfProduction}
                        onChange={(value) =>
                          updateBasicInfo("countryOfProduction", value)
                        }
                        placeholder="Select country"
                        options={countries}
                        className="filter-popup-container-rows-input-container"
                        menuClassName="status-drop-menu-container-countries"
                        optionClassName="status-drop-menu-option-countries"
                      />
                    </div>
                    {/* <div className="basic-info-body-title">
                      <div className="basic-info-body-title-text">Source</div>
                      <div className="basic-info-body-title-input-container">
                        <input
                          className="basic-info-body-title-input"
                          value={basicInfo.source}
                          onChange={(e) =>
                            updateBasicInfo("source", e.target.value)
                          }
                        ></input>
                      </div>
                    </div> */}
                  </div>
                  <div className="basic-info-body-discription">
                    <div className="basic-info-body-disc">
                      <div className="basic-info-body-title-text">
                        Description <span className="required">*</span>
                      </div>
                      <div className="basic-info-body-title-textarea-input-container">
                        <textarea
                          className="basic-info-body-title-input-discription"
                          placeholder="Detailed product features and specifications.."
                          value={basicInfo.description}
                          maxLength={DESCRIPTION_MAX_LENGTH}
                          onChange={(e) =>
                            updateBasicInfo(
                              "description",
                              e.target.value.slice(0, DESCRIPTION_MAX_LENGTH),
                            )
                          }
                        ></textarea>
                        <div className="basic-info-body-title-textarea-counter">
                          {String(basicInfo.description || "").length}/
                          {DESCRIPTION_MAX_LENGTH}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {skusForm.map((skuData, index) => {
              const filteredColorPresets = getFilteredColorPresets(skuData.id);

              return (
                <div
                  className="create-qr-body-commercial-data"
                  key={skuData.id}
                >
                  <div className="create-qr-body-basic-info">
                    <div className="create-qr-basic-info-title">
                      {index + 2}. Commercial Data (SKU List)
                      <div
                        className="create-qr-basic-info-link"
                        onClick={addCommercialSection}
                      >
                        <span style={{ fontSize: "18px" }}>+</span> Add SKU
                      </div>
                    </div>
                    <div className="create-qr-basic-info-body-sku">
                      <div className="create-qr-basic-info-body-input-sku">
                        <div className="Sku-title-container">
                          <div className="Sku-title-container-text">
                            Sku #{index + 1}
                          </div>
                          <div
                            className="Sku-title-container-icon"
                            onClick={() => removeCommercialSection(skuData.id)}
                          >
                            <TrashIcon />
                          </div>
                        </div>
                        <div className="basic-info-body">
                          {/* <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Size <span className="required">*</span>
                            </div>
                            <CustomDropdown
                              rightIcon={<ArrowDownIcon />}
                              value={skuData.size}
                              onChange={(value) =>
                                updateSkuField(skuData.id, "size", value)
                              }
                              placeholder="Select Size"
                              options={[
                                { label: "Small (S)", value: "SMALL" },
                                { label: "Medium (M)", value: "MEDIUM" },
                                { label: "Large (L)", value: "LARGE" },
                                { label: "XL", value: "XL" },
                                { label: "One Size", value: "ONE_SIZE" },
                              ]}
                              className="filter-popup-container-rows-input-container"
                              menuClassName="status-drop-menu-container"
                              optionClassName="status-drop-menu-option"
                            />
                          </div> */}
                          <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Material
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.material}
                                onChange={(e) =>
                                  updateSkuField(
                                    skuData.id,
                                    "material",
                                    e.target.value,
                                  )
                                }
                              ></input>
                            </div>
                          </div>
                          <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Model <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.model}
                                onChange={(e) => {
                                  updateSkuField(
                                    skuData.id,
                                    "model",
                                    e.target.value,
                                  );
                                }}
                              ></input>
                            </div>
                          </div>
                        </div>
                        {/* <div className="basic-info-body"> */}
                        {/**********************Initial Stock Quantity********************************* */}
                        {/* <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Initial Stock Quantity{" "}
                              <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                inputMode="decimal"
                                value={skuData.initialStockQuantity}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                    updateSkuField(
                                      skuData.id,
                                      "initialStockQuantity",
                                      val,
                                    );
                                  }
                                }}
                              ></input>
                            </div>
                          </div> */}
                        {/*************************************************************** */}
                        {/* </div> */}
                        {/* <div className="basic-info-body"> */}
                        {/***************************Reserved Stock Quantity****************************** */}
                        {/* <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Reserved Stock Qty{" "}
                              <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                inputMode="decimal"
                                value={skuData.reservedStockQuantity}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                    updateSkuField(
                                      skuData.id,
                                      "reservedStockQuantity",
                                      val,
                                    );
                                  }
                                }}
                              ></input>
                            </div>
                          </div> */}
                        {/* <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Stock Qty
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                type="number"
                                inputMode="decimal"
                                min="0"
                                value={skuData.stockQuantity}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                    updateSkuField(
                                      skuData.id,
                                      "stockQuantity",
                                      val,
                                    );
                                  }
                                }}
                              />
                            </div>
                          </div> */}
                        {/* </div> */}
                        {/***************************Barcode*********************************/}
                        <div className="basic-info-body">
                          <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Barcode <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.barcode}
                                inputMode="numeric"
                                onChange={(e) =>
                                  updateSkuField(
                                    skuData.id,
                                    "barcode",
                                    e.target.value,
                                  )
                                }
                              ></input>{" "}
                              <div
                                onClick={() =>
                                  setScanningBarcodeSkuId({
                                    skuId: skuData.id,
                                    fieldKey: "barcode",
                                  })
                                }
                                style={{ cursor: "pointer", display: "flex" }}
                              >
                                <ScannerIcon />
                              </div>
                              <div
                                onClick={() => handleGenerateBarcode(skuData)}
                                style={{ cursor: "pointer", display: "flex" }}
                              >
                                <RefreshIcon />
                              </div>
                              {/* <button
                              type="button"
                              className="single-barcode-camera-button"
                              onClick={() =>
                                setScanningBarcodeSkuId(skuData.id)
                              }
                              aria-label="Open barcode scanner"
                            >
                              <FaCamera />
                            </button> */}
                            </div>
                          </div>
                          <div className="basic-info-body-title">
                            <div className="basic-info-body-title-text">
                              Azalea Barcode <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.azaleaBarcode}
                                inputMode="text"
                                onChange={(e) =>
                                  updateSkuField(
                                    skuData.id,
                                    "azaleaBarcode",
                                    e.target.value,
                                  )
                                }
                              ></input>
                              {/* <div
                              onClick={() => handleGenerateBarcode(skuData)}
                              style={{ cursor: "pointer", display: "flex" }}
                            >
                              <RefreshIcon />
                            </div> */}
                              {/* <button
                              type="button"
                              className="single-barcode-camera-button"
                              onClick={() =>
                                setScanningBarcodeSkuId(skuData.id)
                              }
                              aria-label="Open barcode scanner"
                            >
                              <FaCamera />
                            </button> */}{" "}
                              <div
                                onClick={() =>
                                  setScanningBarcodeSkuId({
                                    skuId: skuData.id,
                                    fieldKey: "azaleaBarcode",
                                  })
                                }
                                style={{ cursor: "pointer", display: "flex" }}
                              >
                                <ScannerIcon />
                              </div>
                            </div>
                          </div>
                          {/*******************************************************************/}
                        </div>
                        {/* <div className="basic-info-body">
                        <div className="basic-info-body-title">
                          <div className="basic-info-body-title-text">
                            Unit of Measure <span className="required">*</span>
                          </div>
                          <CustomDropdown
                            rightIcon={<ArrowDownIcon />}
                            value={skuData.unitOfMeasure}
                            onChange={(value) =>
                              updateSkuField(skuData.id, "unitOfMeasure", value)
                            }
                            placeholder="Select country"
                            options={[
                              { label: "Piece", value: "PIECE" },
                              { label: "Kilograms", value: "KILOGRAM" },
                              { label: "Pound", value: "POUND" },
                              { label: "Set", value: "SET" },
                            ]}
                            className="filter-popup-container-rows-input-container-measure"
                            menuClassName="status-drop-menu-container"
                            optionClassName="status-drop-menu-option"
                          />
                        </div>

                      </div> */}
                        <div className="basic-info-body-res">
                          <div className="basic-info-body-dimension">
                            <div className="basic-info-body-title-text">
                              Package Dimensions{" "}
                              <span className="required">*</span>
                            </div>
                            <div className="commercial-data-sku-dimension">
                              <div className="basic-info-sku-title-input-container">
                                <input
                                  className="basic-info-body-title-inputfi"
                                  inputMode="decimal"
                                  placeholder="L"
                                  value={
                                    skuData.packageDimensions?.length || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "packageDimensions",
                                        "length",
                                        val,
                                      );
                                    }
                                  }}
                                ></input>
                                <input
                                  className="basic-info-body-title-inputse"
                                  placeholder="W"
                                  inputMode="decimal"
                                  value={skuData.packageDimensions?.width || ""}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "packageDimensions",
                                        "width",
                                        val,
                                      );
                                    }
                                  }}
                                />

                                <input
                                  className="basic-info-body-title-inputen"
                                  placeholder="H"
                                  inputMode="decimal"
                                  value={
                                    skuData.packageDimensions?.height || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "packageDimensions",
                                        "height",
                                        val,
                                      );
                                    }
                                  }}
                                />
                              </div>
                              {/* <CustomDropdown
                              rightIcon={<ArrowDownIcon />}
                              value={
                                skuData.packageDimensions?.unitOfDimensions ||
                                "CM"
                              }
                              onChange={(value) =>
                                updateSkuNestedField(
                                  skuData.id,
                                  "packageDimensions",
                                  "unitOfDimensions",
                                  value,
                                )
                              }
                              placeholder="Unit of Measure"
                              options={[
                                { label: "Centimeter", value: "CM" },
                                { label: "Meter", value: "M" },
                              ]}
                              className="filter-popup-container-rows-input-container-unit"
                              menuClassName="status-drop-menu-container"
                              optionClassName="status-drop-menu-option"
                            /> */}
                            </div>
                          </div>
                          <div className="basic-info-body-dimension">
                            <div className="basic-info-body-title-text">
                              Product Dimensions{" "}
                              <span className="required">*</span>
                            </div>
                            <div className="commercial-data-sku-dimension">
                              <div className="basic-info-sku-title-input-container">
                                <input
                                  className="basic-info-body-title-inputfi"
                                  inputMode="decimal"
                                  placeholder="L"
                                  value={
                                    skuData.productDimensions?.length || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "productDimensions",
                                        "length",
                                        val,
                                      );
                                    }
                                  }}
                                ></input>
                                <input
                                  className="basic-info-body-title-inputse"
                                  placeholder="W"
                                  inputMode="decimal"
                                  value={skuData.productDimensions?.width || ""}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "productDimensions",
                                        "width",
                                        val,
                                      );
                                    }
                                  }}
                                />

                                <input
                                  className="basic-info-body-title-inputen"
                                  placeholder="H"
                                  inputMode="decimal"
                                  value={
                                    skuData.productDimensions?.height || ""
                                  }
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || /^\d*\.?\d*$/.test(val)) {
                                      updateSkuNestedField(
                                        skuData.id,
                                        "productDimensions",
                                        "height",
                                        val,
                                      );
                                    }
                                  }}
                                />
                              </div>
                              {/* <CustomDropdown
                              rightIcon={<ArrowDownIcon />}
                              value={
                                skuData.productDimensions?.unitOfDimensions ||
                                "CM"
                              }
                              onChange={(value) =>
                                updateSkuNestedField(
                                  skuData.id,
                                  "productDimensions",
                                  "unitOfDimensions",
                                  value,
                                )
                              }
                              placeholder="Unit of Measure"
                              options={[
                                { label: "Centimeter", value: "CM" },
                                { label: "Meter", value: "M" },
                              ]}
                              className="filter-popup-container-rows-input-container-unit"
                              menuClassName="status-drop-menu-container"
                              optionClassName="status-drop-menu-option"
                            /> */}
                            </div>
                          </div>
                        </div>
                        <div className="basic-info-body-res">
                          <div className="basic-info-body-dimension">
                            <div className="basic-info-body-title-text">
                              Package Weight <span className="required">*</span>
                            </div>
                            <div className="commercial-data-sku-dimension">
                              <div className="basic-info-sku-title-input-container">
                                <input
                                  className="basic-info-body-title-inputweight"
                                  inputMode="decimal"
                                  placeholder="Wieght"
                                  value={skuData.packageWeight}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      updateSkuField(
                                        skuData.id,
                                        "packageWeight",
                                        val,
                                      );
                                    }
                                  }}
                                ></input>
                              </div>
                            </div>
                          </div>
                          <div className="basic-info-body-dimension">
                            <div className="basic-info-body-title-text">
                              Product Weight <span className="required">*</span>
                            </div>
                            <div className="commercial-data-sku-dimension">
                              <div className="basic-info-sku-title-input-container">
                                <input
                                  className="basic-info-body-title-inputweight"
                                  inputMode="decimal"
                                  placeholder="Net Weight"
                                  value={skuData.productWeight}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*\.?\d*$/.test(val)) {
                                      updateSkuField(
                                        skuData.id,
                                        "productWeight",
                                        val,
                                      );
                                    }
                                  }}
                                ></input>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="basic-info-body-res">
                          {/************************color*************************** */}
                          <div
                            className="basic-info-body-title color-selector-wrap"
                            ref={(el) => {
                              colorDropdownRefs.current[skuData.id] = el;
                            }}
                          >
                            <div className="basic-info-body-title-text">
                              Color <span className="required">*</span>
                            </div>
                            {/* <div className="basic-info-body-title-input-container">
                            <input
                              className="basic-info-body-title-input"
                              placeholder="Click to select color"
                              value={skuData.colorName}
                              readOnly
                              onClick={() =>
                                setOpenColorPickerSkuId((prev) =>
                                  prev === skuData.id ? null : skuData.id,
                                )
                              }
                            ></input>
                          </div> */}
                            <div className="basic-info-body-title-input-container color-hex-trigger">
                              <div
                                className="color-swatch-button"
                                onClick={() =>
                                  setOpenColorPickerSkuId((prev) =>
                                    prev === skuData.id ? null : skuData.id,
                                  )
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  background: skuData.colorValue || "#000000",
                                }}
                              />
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.colorValue}
                                placeholder="#000000"
                                maxLength={7}
                                onChange={(e) =>
                                  handleColorHexChange(
                                    skuData.id,
                                    e.target.value,
                                  )
                                }
                                onBlur={() => {
                                  const normalized = normalizeHexColor(
                                    skuData.colorValue,
                                  );
                                  if (normalized) {
                                    setSkuColor(
                                      skuData.id,
                                      getColorNameFromHex(normalized),
                                      normalized,
                                    );
                                  }
                                }}
                              />
                            </div>
                            {openColorPickerSkuId === skuData.id ? (
                              <div className="color-selector-menu">
                                <input
                                  className="color-preset-search-input"
                                  value={
                                    colorPresetSearchBySkuId[skuData.id] || ""
                                  }
                                  placeholder="Search color"
                                  onChange={(e) =>
                                    updateColorPresetSearch(
                                      skuData.id,
                                      e.target.value,
                                    )
                                  }
                                />
                                {filteredColorPresets.length ? (
                                  <div className="color-presets-grid">
                                    {filteredColorPresets.map((color) => (
                                      <div
                                        key={color.value}
                                        className="color-preset-button"
                                        onClick={() => {
                                          setSkuColor(
                                            skuData.id,
                                            color.name,
                                            color.value,
                                          );
                                          setOpenColorPickerSkuId(null);
                                        }}
                                      >
                                        <span
                                          className="color-preset-dot"
                                          style={{ background: color.value }}
                                        />
                                        <span className="color-preset-label">
                                          {color.name}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="color-preset-empty">
                                    No colors found
                                  </div>
                                )}
                                <div className="color-picker-background">
                                  <input
                                    type="color"
                                    value={
                                      normalizeHexColor(skuData.colorValue) ||
                                      "#000000"
                                    }
                                    onChange={(e) =>
                                      setSkuColor(
                                        skuData.id,
                                        getColorNameFromHex(e.target.value),
                                        e.target.value.toUpperCase(),
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            ) : null}
                          </div>

                          <div className="basic-info-body-sku">
                            <div className="basic-info-body-title-text">
                              SKU code <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                className="basic-info-body-title-input"
                                value={skuData.skuCode}
                                onChange={(e) =>
                                  updateSkuField(
                                    skuData.id,
                                    "skuCode",
                                    e.target.value,
                                  )
                                }
                              ></input>
                              <div
                                onClick={() => handleGenerateSkuCode(skuData)}
                                style={{ cursor: "pointer", display: "flex" }}
                              >
                                <RefreshIcon />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="basic-info-body">
                          {/* <div className="basic-info-body-price">
                          <div className="basic-info-body-title-text">
                            Selling Price <span className="required">*</span>
                          </div>
                          <div className="basic-info-body-title-input-container">
                            <input
                              inputMode="decimal"
                              className="basic-info-body-title-input"
                              value={skuData.price}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d*\.?\d*$/.test(val)) {
                                  updateSkuField(skuData.id, "price", val);
                                }
                              }}
                            ></input>
                          </div>
                        </div> */}

                          <div className="basic-info-body-price">
                            <div className="basic-info-body-title-text">
                              Cost Price
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                inputMode="decimal"
                                className="basic-info-body-title-input"
                                value={skuData.costPriceValue || ""}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*\.?\d*$/.test(val)) {
                                    updateSkuField(
                                      skuData.id,
                                      "costPriceValue",
                                      val,
                                    );
                                  }
                                }}
                              ></input>
                            </div>
                          </div>

                          <div className="basic-info-body-currency">
                            <div className="basic-info-body-title-text">
                              Currency <span className="required">*</span>
                            </div>

                            <CustomDropdown
                              rightIcon={<ArrowDownIcon />}
                              value={skuData.currency}
                              onChange={(value) =>
                                updateSkuField(skuData.id, "currency", value)
                              }
                              placeholder="USD $"
                              options={[
                                { label: "USD $", value: "USD" },
                                { label: "LBP L.L.", value: "LBP" },
                                { label: "EURO €", value: "EURO" },
                              ]}
                              className="filter-currency-popup-container-rows-input-container"
                              menuClassName="status-drop-menu-container"
                              optionClassName="status-drop-menu-option"
                            />
                          </div>
                          {/* <div className="basic-info-body-price">
                          <div className="basic-info-body-title-text">
                            Cost Price <span className="required">*</span>
                          </div>
                          <div className="basic-info-body-title-input-container">
                            <input
                              inputMode="decimal"
                              className="basic-info-body-title-input"
                              value={skuData.costPriceValue || ""}
                              onChange={(e) => {
                                const val = e.target.value;
                                if (/^\d*\.?\d*$/.test(val)) {
                                  updateSkuField(
                                    skuData.id,
                                    "costPriceValue",
                                    val,
                                  );
                                }
                              }}
                            ></input>
                          </div>
                        </div> */}
                          <div className="basic-info-body-price-selling">
                            <div className="basic-info-body-title-text">
                              Selling Price <span className="required">*</span>
                            </div>
                            <div className="basic-info-body-title-input-container">
                              <input
                                inputMode="decimal"
                                className="basic-info-body-title-input"
                                value={skuData.price}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*\.?\d*$/.test(val)) {
                                    updateSkuField(skuData.id, "price", val);
                                  }
                                }}
                              ></input>
                            </div>
                          </div>
                          {/* <div className="basic-info-body-currency">
                          <div className="basic-info-body-title-text">
                            Currency <span className="required">*</span>
                          </div>

                          <CustomDropdown
                            rightIcon={<ArrowDownIcon />}
                            value={skuData.currency}
                            onChange={(value) =>
                              updateSkuField(skuData.id, "currency", value)
                            }
                            placeholder="USD ($)"
                            options={[
                              { label: "USD ($)", value: "USD" },
                              { label: "LBP L.L.", value: "LBP" },
                              { label: "EURO €", value: "EURO" },
                            ]}
                            className="filter-popup-container-rows-input-container"
                            menuClassName="status-drop-menu-container"
                            optionClassName="status-drop-menu-option"
                          />
                        </div> */}
                        </div>
                        <div className="basic-info-body-discription">
                          <div className="basic-info-sku-disc">
                            <div className="basic-info-body-title-text">
                              Technical Specifications
                              {/* <span className="required">*</span> */}
                            </div>
                            <div className="basic-info-sku-title-textarea-input-container">
                              <textarea
                                className="basic-info-body-title-input-text-area"
                                placeholder="Weight capacity, fire rating, etc..."
                                value={skuData.technicalSpecs}
                                onChange={(e) =>
                                  updateSkuField(
                                    skuData.id,
                                    "technicalSpecs",
                                    e.target.value,
                                  )
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="create-qr-body-proiduct-image">
                          <div className="create-qr-body-proiduct-image-title">
                            Product Images
                          </div>
                          <div className="create-qr-body-image-body">
                            <label
                              htmlFor={`product-images-upload-${skuData.id}`}
                              className="create-qr-body-image-upload"
                            >
                              <Uploadbutton />
                              <span className="create-qr-body-image-upload-text">
                                Upload Images
                              </span>
                            </label>
                            <input
                              id={`product-images-upload-${skuData.id}`}
                              className="create-qr-body-proiduct-image-input"
                              type="file"
                              accept="image/*"
                              multiple
                              onChange={(e) =>
                                handleProductImagesChange(skuData.id, e)
                              }
                            ></input>
                            {(skuData.images || []).length > 0 ? (
                              <div className="create-qr-uploaded-images-list">
                                {(skuData.images || []).map((img) => (
                                  <div
                                    key={img.id}
                                    className="create-qr-uploaded-image-item"
                                  >
                                    <span className="create-qr-uploaded-image-name">
                                      {img.name}
                                    </span>
                                    <div
                                      className="create-qr-uploaded-image-remove"
                                      onClick={() =>
                                        setSkusForm((prev) =>
                                          prev.map((sku) =>
                                            sku.id === skuData.id
                                              ? {
                                                  ...sku,
                                                  images: (
                                                    sku.images || []
                                                  ).filter(
                                                    (item) =>
                                                      item.id !== img.id,
                                                  ),
                                                }
                                              : sku,
                                          ),
                                        )
                                      }
                                    >
                                      X
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="create-qr-uploaded-image-item-empty"></div>
                            )}
                          </div>
                        </div>
                        <div className="create-qr-body-proiduct-image">
                          <div className="create-qr-body-proiduct-image-title">
                            Product Video
                          </div>
                          <div className="create-qr-body-image-body">
                            <label
                              htmlFor={`product-videos-upload-${skuData.id}`}
                              className="create-qr-body-image-upload"
                            >
                              <Uploadbutton />
                              <span className="create-qr-body-image-upload-text">
                                Upload Video
                              </span>
                            </label>
                            <input
                              id={`product-videos-upload-${skuData.id}`}
                              className="create-qr-body-proiduct-image-input"
                              type="file"
                              accept="video/*"
                              multiple
                              onChange={(e) =>
                                handleProductVideosChange(skuData.id, e)
                              }
                            ></input>
                            {(skuData.videos || []).length > 0 ? (
                              <div className="create-qr-uploaded-images-list">
                                {(skuData.videos || []).map((vid) => (
                                  <div
                                    key={vid.id}
                                    className="create-qr-uploaded-image-item"
                                  >
                                    <span className="create-qr-uploaded-image-name">
                                      {vid.name}
                                    </span>
                                    <div
                                      className="create-qr-uploaded-image-remove"
                                      onClick={() =>
                                        setSkusForm((prev) =>
                                          prev.map((sku) =>
                                            sku.id === skuData.id
                                              ? {
                                                  ...sku,
                                                  videos: (
                                                    sku.videos || []
                                                  ).filter(
                                                    (item) =>
                                                      item.id !== vid.id,
                                                  ),
                                                }
                                              : sku,
                                          ),
                                        )
                                      }
                                    >
                                      X
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="create-qr-uploaded-image-item-empty"></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="create-qr-action-buttons">
            {fromScanner ? (
              <div
                className={`create-qr-action-create ${
                  isProductSubmitIncomplete
                    ? "create-qr-action-create-incomplete"
                    : ""
                }`}
                onClick={handleUpdate}
              >
                Update Product
              </div>
            ) : (
              <div
                className={`create-qr-action-create ${
                  isProductSubmitIncomplete
                    ? "create-qr-action-create-incomplete"
                    : ""
                }`}
                onClick={handleCreate}
              >
                Create
              </div>
            )}

            <div
              className="create-qr-action-cancel"
              onClick={() => navigateWithTableState("/Qr-code-management")}
            >
              Cancel
            </div>
          </div>
          <div className="create-qr-action-buttom"></div>
        </div>
      </div>
      {scanningBarcodeSkuId && (
        <SingleBarcodeScanner
          onDetected={handleBarcodeDetected}
          onClose={() => setScanningBarcodeSkuId(null)}
        />
      )}
    </div>
  );
}

export default SingleQRcode;
